import { apiRequest } from "@portal/lib/ky/utils";
import { DocumentFilters } from "@portal/store/Filters/documents/type";
import { RequestConfig } from "@portal/types/common";
import {
  CreateDocument,
  DOCUMENT_FILTER,
  DocumentList,
  DocumentTypes,
} from "@portal/types/entities/documents";
import { PageList } from "@portal/types/page-list";

export async function getDocumentTypes(filter: DOCUMENT_FILTER) {
  const data = await apiRequest<unknown, PageList<DocumentTypes, unknown>>({
    method: "POST",
    url: "v1/documents/types",
    data: { ...filter },
    searchParams: { page: 1, size: 10 },
  });
  return await data.json();
}

export async function createADocument(params: CreateDocument) {
  await apiRequest<CreateDocument, unknown>({
    method: "POST",
    url: "v1/documents",
    data: { ...params },
  });
}

export async function getDocumentsList(params: RequestConfig<DocumentFilters>) {
  const { page, size, filters } = params;
  const data = await apiRequest<
    RequestConfig<DocumentFilters>["filters"],
    PageList<DocumentList, unknown>
  >({
    method: "POST",
    url: "v1/documents/report",
    data: filters,
    searchParams: { page, size },
  });
  return await data.json();
}

export async function deleteDocument(id: string) {
  await apiRequest<undefined, undefined>({
    method: "DELETE",
    url: `v1/documents/${id}`,
  });
}
